import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/home/onboarding')({
  staticData: { team: 'fe-clm' },
});
